import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../components-v2/Button';
import { Pill } from '../../../../components-v2/Pill';
import { TagIcon } from '../../../svgs/icons/TagIcon';
import { TagPickerPopover } from '../TagPickerPopover';
import { styleSheet } from './styles';

interface IProps {
	selectedTag?: Api.IAccountTag;
	onTagSelected(tag: Api.IAccountTag): void;
	onTagCleared(): void;
	isVisible?: boolean;
	styles?: StyleDeclarationValue[];
}

export function RowTagFilterShortcut({
	selectedTag,
	onTagSelected,
	onTagCleared,
	isVisible = false,
	styles = [],
}: IProps) {
	const [popoverOpen, setPopoverOpen] = React.useState(false);

	if (selectedTag) {
		return (
			<div className={css(styleSheet.chipWrapper, ...styles)} onClick={e => e.stopPropagation()}>
				<Pill
					variant='tag'
					color={selectedTag.color || 'blue'}
					label={selectedTag.name || ''}
					onRemove={onTagCleared}
				/>
			</div>
		);
	}

	const triggerVisible = isVisible || popoverOpen;

	return (
		<TagPickerPopover
			onTagSelected={onTagSelected}
			onOpenChange={setPopoverOpen}
			trigger={
				<Button
					variant='ghost'
					size='sm'
					styles={[styleSheet.trigger, triggerVisible ? styleSheet.triggerVisible : null, ...styles]}
					onClick={e => e.stopPropagation()}
					title='View stats filtered by tag'
				>
					<TagIcon />
					<span>Filter stats by tag</span>
				</Button>
			}
		/>
	);
}
